import React, { useState } from "react";
import "./style/Login.module.scss";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FInput from "../../components/FInput/FInput";
import FInputt from "../../components/FInputt/FInputt";

import { Carousel } from "react-responsive-carousel";
import { useLogin } from "./hooks/useLogin";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";

const Login = () => {
  const { formik, phoneNumber, setPhoneNumber, countryCode, setCountryCode } =
    useLogin();
   
  const handleSubmit = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  }
 
  return (
    <>
      <div className="sm:border-0 sm:border-red-600 sm:h-screen sm:relative sm:grid sm:place-items-center">
        <div className=" h-screen-1/2 w-screen border-0 sm:pb-5 md:pb-0 lg:pb-1 sm:w-[670px] md:w-[770px] lg:w-[970px] sm:shadow-2xl sm:absolute border-red-600 grid grid-rows-6 sm:grid-rows-1 grid-cols-1 sm:grid-cols-2">
          <Swiper
            pagination={{
              clickable: true,
              renderBullet: function (index, className) {
                console.log(className);
                return (
                  '<span class="' +
                  className +
                  '" style=" width:26px; height:3px; border-radius: 5px;"></span>'
                );
              },
            }}
            style={{
              "--swiper-navigation-color": "black",
              "--swiper-pagination-color": "black",
            }}
            modules={[Pagination]}
            className="border-0 border-red-600 w-full gap-0 row-span-3 sm:grid-rows-1 col-span-1"
          >
            <SwiperSlide>
              <img
                className="rounded-bl-[100px] w-full h-screen-1/2 "
                src="https://dev-app.tufiado.com/user/resources/banner1.png"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                className="rounded-bl-[100px] w-full img-carousel"
                src="https://dev-app.tufiado.com/user/resources/banner2.png"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                className="rounded-bl-[100px] w-full img-carousel "
                src="https://dev-app.tufiado.com/user/resources/banner3.png"
              />
            </SwiperSlide>
          </Swiper>
          <div
            className="border-0 border-blue-600 w-full h-[98%] sm:h-[110%] sm:px-4 md:px-8 lg:px-10 row-span-3 sm:grid-rows-1 col-span-1 sm:grid sm:items-center"
          >
            <form
              className="text-center pt-10 xs:pt-12"
              onSubmit={handleSubmit}
            >
              <div className="text-title font-bold">Bienvenido a Fiado</div>
              <div className="text-small font-regular mx-5 mt-2">
                Selecciona la bandera del país al que pertenece tu celular
              </div>
              <div className="border-0 px-5 mt-[15px]">
                <FInputText
                  type="PhoneInput"
                  title=""
                  placeholder="Ingresa tu teléfono"
                  value={formik.values.phoneNumber}
                  onChange={(value) => {
                    formik.setFieldValue("phoneNumber", value);
                  }}
                  errorMessage={formik.errors.phoneNumber}
                />
              </div>
              <div className="m-4 pb-4 sm:pb-0 px-4">
                <Fbutton
                  value={"Continuar"}
                  disabled={!(formik.isValid && formik.dirty)}
                  onClick={formik.handleSubmit}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
